
import { CornerRightDown } from "lucide-react";

type ResizeHandleProps = {
  selected: boolean;
  onResizeStart: (e: React.MouseEvent) => void;
};

const ResizeHandle = ({ selected, onResizeStart }: ResizeHandleProps) => {
  if (!selected) return null;

  return (
    <div 
      className="absolute bottom-0 right-0 w-5 h-5 bg-gray-400 opacity-70 rounded-bl cursor-nwse-resize z-50 nodrag flex items-center justify-center"
      onMouseDown={onResizeStart}
    >
      <CornerRightDown className="h-3 w-3 text-white" />
    </div>
  );
};

export default ResizeHandle;
